export default __webpack_public_path__ + "static/PT-mETH-b6950550feb5e46f3214f2b8c49d4a2f.svg";